'use client';

import React from 'react';
import { Menu as MenuIcon } from 'lucide-react';
import { css, cx } from 'styled-system/css';

import Connect2Wallet from '@shaojiang/components/Connect2Wallet';
import LangSwitch from '@shaojiang/components/LangSwitch';
import ShaojiangLink from '@shaojiang/components/ShaojiangLink';
import ThemeSwitch from '@shaojiang/components/ThemeSwitch';
import { IconButton } from '@shaojiang/components/ui/icon-button';
import { useSidebar } from '@shaojiang/hooks';
import useScrollDirection from '@shaojiang/hooks/useScrollDirection';
import { useDomStore } from '@shaojiang/store/dom';
import { Direction } from '@shaojiang/types/window';

const headerStyle = css({
  position: 'sticky',
  top: '0',
  zIndex: 'sticky',
  mx: 'auto',
  maxW: 'page',
  transition: 'transform 0.2s ease',
});

const hiddenStyle = css({ transform: 'translateY(-64px)' });

const barStyle = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  px: { base: '4', smDown: '2' },
  py: '2',
  transition: 'all 0.2s ease',
});

const scrolledBarStyle = css({
  bg: 'bg.surface',
  boxShadow: 'lg',
  mx: { base: '4', smDown: '0' },
});

export default function Header() {
  const setMobileSidebarOpen = useDomStore((state) => state.setMobileSidebarOpen);
  const scrollTop = useDomStore((state) => state.scrollTop);
  const { mdDown } = useSidebar();
  const scrollingDirection = useScrollDirection();

  const scrolled = scrollTop > 0;

  return (
    <header
      className={cx(headerStyle, scrolled && scrollingDirection === Direction.Down && hiddenStyle)}
    >
      <div className={cx(barStyle, scrolled && scrolledBarStyle)}>
        <div className={css({ flex: '1', display: 'flex', alignItems: 'center', gap: '2' })}>
          {mdDown && (
            <IconButton
              variant='ghost'
              colorPalette='gray'
              aria-label='Open menu'
              onClick={() => setMobileSidebarOpen(true)}
            >
              <MenuIcon />
            </IconButton>
          )}
          <ShaojiangLink
            href='/'
            className={css({
              color: 'primary.9!',
              textStyle: 'lg',
              fontWeight: 'bold',
              _hover: { textDecoration: 'none' },
            })}
          >
            Shaojiang.io
          </ShaojiangLink>
        </div>
        <ul
          className={css({
            display: 'flex',
            alignItems: 'center',
            gap: { base: '1', smDown: '0' },
          })}
        >
          <li>
            <LangSwitch />
          </li>
          <li>
            <ThemeSwitch />
          </li>
          <li>
            <Connect2Wallet />
          </li>
        </ul>
      </div>
    </header>
  );
}
